module.exports = __webpack_public_path__ + "static/media/password.4b7b7b82.svg";